<template>
	<div id="hrms75e-detail-cours">
    <form class="form-horizontal">
      <div class="form-group margin-b-5">
        <label class="col-md-3 control-label">{{ labels['HRMS75EC1']['10'] }}</label>
        <div class="col-md-8">
          <hrms-dropdown-year
              v-model="paramSearchDetailCours.year"
              :disabled="eventBtn === 'edit'"
              :nowLang="nowLang" />

        </div>
      </div>
    </form>
    <form class="form-horizontal">
      <div class="form-group margin-b-5">
        <label class="col-md-3 control-label">{{ labels['HRMS75EC1']['20'] }}</label>
        <div class="col-md-8">
          <hrms-lov   v-model="paramSearchDetailCours.codempid"
                      :nowLang="nowLang"
                      lovType="codempid"
                      :disabled="eventBtn === 'edit'"
                      v-validate="'required'"
                      data-vv-value-path="inputValue"
                      data-vv-name="codempid"
                      name="codempid"  />
          <div class="text-error" v-show="errors.has('codempid')">{{errors.first('codempid')}}</div>
        </div>
      </div>
    </form>

    <div class="detail detail-responsive panel-detail-filter">
           <hrms-table :labels="labels"
                       :columns="detailCoursColumns"
                       :data="detail.table"
                       :searchDisp="false"
                       :searchIndex="searchIndex"
                       :addInlineEventBool="true"
                       :deleteInlineEventBool="true"
                       :saveInlineBtnDisp="false"
                       :saveInlineEvent="callSave"
                       :nowLang="nowLang"
                       ref="detailCoursTable" />

    </div>
    <div class="col-md-12 ">
      <button type="button" class="btn bg-color-skin pull-left" @click="toggleDetailCours()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms75e-detail-cours',
  data () {
    return {
      paramSearchDetailCours: {
        codempid: this.searchDetailCours.codempid,
        year: this.searchDetailCours.year
      }
    }
  },
  watch: {
    'searchDetailCours.year' () {
      this.paramSearchDetailCours.year = this.searchDetailCours.year
    },
    'searchDetailCours.codempid' () {
      this.paramSearchDetailCours.codempid = this.searchDetailCours.codempid
    },
    'paramSearchDetailCours.year' () {
      this.$set(this.searchDetailCours, 'year', this.paramSearchDetailCours.year)
      if (this.paramSearchDetailCours.codempid !== '') {
        if (this.eventBtn === 'add') {
          let detailParams = {
            p_dteyear: this.paramSearchDetailCours.year,
            p_codempid_query: this.paramSearchDetailCours.codempid
          }
          this.receivedHrms75eDetail(detailParams)
        }
      }
    },
    'paramSearchDetailCours.codempid' () {
      this.$set(this.searchDetailCours, 'codempid', this.paramSearchDetailCours.codempid)
      if (this.paramSearchDetailCours.codempid !== '') {
        if (this.eventBtn === 'add') {
          let detailParams = {
            p_dteyear: this.paramSearchDetailCours.year,
            p_codempid_query: this.paramSearchDetailCours.codempid
          }
          this.receivedHrms75eDetail(detailParams)
        }
      }
    }
  },
  methods: {
    toggleDetailCours () {
      let _this = this
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          _this.$refs.detailCoursTable.$emit('$saveInlineEventBuiltIn')
        }
      })
    },
    callSave (dataRowsHasFlg) {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          let searchParams = {
            p_codempid_query: _this.paramSearchDetailCours.codempid,
            p_dteyear: _this.paramSearchDetailCours.year
          }
          _this.postHrms75eDetailCoursSave({ dataRowsHasFlg: dataRowsHasFlg, searchIndex: _this.searchIndex, searchDetailCours: searchParams })
        }
      })
    }
  },
  props: [
    'nowLang',
    'labels',
    'detail',
    'searchIndex',
    'searchDetailCours',
    'receivedHrms75eDetail',
    'indexSelected',
    'eventBtn',
    'labelsButton',
    'lovCurrentDesc',
    'detailCoursColumns',
    'postHrms75eDetailCoursSave'
  ]
}
</script>



// WEBPACK FOOTER //
// detailCours.vue?bee80286